import React, { useState, useEffect } from 'react';
import { Group, Image } from 'react-konva';
import Score from './Score';
import {
  GetScoreDefn,
  getScoreText,
  GetTextColor,
  isNullOrUndefined,
} from 'utils/Global';
import EAutoScoreType from 'enums/EAutoScoreType';
import EColors from 'enums/EColors';
import { getScoreToolTip } from './utils';
import { RMSvgIconImage } from 'components/customComponents/CommonComponents/RMSvgIcon';
import { UpdateGlobalDataStoreVersion } from 'business/services/GlobalService';
import {
  ALLSCORESGROUPSSTORE,
  MANUALSCOREGROUPSSTORE,
  SCOREDEFNSTORE,
} from 'utils/IndexDBGlobal';
import { waitForValue } from 'components/commandpanel/ImageTuning/utils';
import { useIsUpdatingGlobalData } from 'redux/hooks/experiment';
import { useSystemProperty } from 'CustomHooks/useSystemProperty';
import { PropertyConstants } from 'enums/PropertyConstants';

const disputeIcon = RMSvgIconImage({ name: 'DisputeScoreIcon' });

export default function Scores(props: any) {
  const [scoreComponents, setScoreComponents] = useState<JSX.Element[]>([]);
  const { updatingGlobalData, setUpdatingGlobalData } = useIsUpdatingGlobalData();
  const AllowDisputedScoreDrawing = useSystemProperty(
    PropertyConstants.AllowDisputedScoreDrawing,
    false,
  );
  useEffect(() => {
    const fetchScores = async () => {
      const components = await getScoresComponents();
      setScoreComponents(components);
    };

    fetchScores();
  }, [props.scoresOfWellDrops, AllowDisputedScoreDrawing]);

  async function getScoresComponents() {
    if (isNullOrUndefined(GetScoreDefn())) {
      return [];
    }
    const scoreComponents = [];
    const isDisputed = props.scoresOfWellDrops?.some((el) => el.isDisputed === true);

    if (isDisputed && AllowDisputedScoreDrawing) {
      scoreComponents.push(
        <Image
          id="scores-img-component"
          x={props.x}
          y={props.y}
          width={props.width}
          height={props.height}
          image={disputeIcon}
        />,
      );
    }

    for (let i = 0; i < props.scoresOfWellDrops?.length; i++) {
      const wellDropScore = props.scoresOfWellDrops[i];
      if (wellDropScore.isUVIndicator) {
        const indicatorColor = `rgb(${wellDropScore.colorRGB})`;
        const x = props.x + props.width * i;
        const y = props.y;
        const scale = props.scale ? props.scale : 1;
        scoreComponents.push(
          <Group id={`scores-img-component-${i}`} key={`score-${i}`}>
            <Score
              id={`scores-${i}`}
              x={x}
              y={y}
              width={props.width}
              height={props.height}
              color={indicatorColor}
              scale={scale}
              Scores={wellDropScore.scoreName}
              textcolor={GetTextColor(wellDropScore.colorRGB)}
              isDisputed={false}
              scoreType={wellDropScore.scoreType}
              toolTipText={getScoreToolTip(wellDropScore, null)}
              sizeDetails={props.sizeDetails}
            />
          </Group>,
        );
        continue;
      }
      let score = GetScoreDefn().find(
        (score) => score.wellDropScoreId === wellDropScore.wellDropScoreId,
      );
      if (!score) {
        if (!updatingGlobalData) {
          setUpdatingGlobalData(true);
          // await for score definition gdata to update version
          await UpdateGlobalDataStoreVersion([SCOREDEFNSTORE.name]);
          // fire and forget for remaining scores related gdata
          UpdateGlobalDataStoreVersion([
            ALLSCORESGROUPSSTORE.name,
            MANUALSCOREGROUPSSTORE.name,
          ]).finally(() => {
            setUpdatingGlobalData(false);
          });
        }

        score = await waitForValue({
          action: () => {
            return GetScoreDefn().find(
              (score) => score.wellDropScoreId === wellDropScore.wellDropScoreId,
            );
          },
        });
      }

      const color = `rgb(${score.color})`;
      let x = props.x + props.width * i;
      const y = props.y;
      if (isDisputed && AllowDisputedScoreDrawing) {
        x = x + props.width;
      }

      const scale = props.scale ? props.scale : 1;
      const scoreComponent = (
        <Group id={`scores-img-component-${i}`} key={`score-${i}`}>
          <Score
            id={`scores-${i}`}
            x={x}
            y={y}
            width={props.width}
            height={props.height}
            color={color}
            scale={scale}
            Scores={getScoreText(wellDropScore, score)}
            textcolor={
              wellDropScore.autoScoreType === EAutoScoreType.IP
                ? EColors.White
                : GetTextColor(score.color)
            }
            isDisputed={wellDropScore.isDisputed}
            scoreType={wellDropScore.scoreType}
            toolTipText={getScoreToolTip(wellDropScore, score)}
            sizeDetails={props.sizeDetails}
          />
        </Group>
      );
      scoreComponents.push(scoreComponent);
    }

    return scoreComponents;
  }

  return <Group>{scoreComponents}</Group>;
}
